import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'castPipe',
  standalone: false
})
export class CastPipe implements PipeTransform {
  /**
   * Casts the provided value to the specified type.
   *
   * @typeParam T - The target type to cast the value to.
   * @param value - The value to be cast.
   * @param castType - The type to cast the value to (used for type inference, not at runtime).
   * @returns The value cast to the specified type.
   */
  transform<T>(value: unknown, castType: T | undefined): T {
    return value as unknown as T;
  }
}
